import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requirePersonsMaySignUp } from '../auth/sign-up-policy.ts'
import { entryRoute } from './entry.tsx'
import { NAV_PATHS } from '../navigation/paths.ts'

// The player's wizard, one step past the fork. Shut while persons may not sign up, it
// answers as a path that does not exist (docs/adr/0013-la-prima-release-registra-solo-le-societa.md).
export const signUpPlayerRoute = createRoute({
  getParentRoute: () => entryRoute,
  path: NAV_PATHS.signUpPlayer,
  beforeLoad: requirePersonsMaySignUp,
  component: lazyRouteComponent(() => import('../pages/sign-up-player.tsx')),
})
